import type { QueryParams } from '~/types/api'
import type { PageDetail, PagePagedResult, SlugTranslation } from '~/types/api'
import { ApiLocale } from '~/constants/locales'

export function createPagesRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'pages'
  const DOMAIN_TRANSLATE = 'translate'
  const LANG = 'pages'

  async function getAll(params?: QueryParams) {
    return get<PagePagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<PageDetail>([DOMAIN, nid.toString()]) // TODO: langPath: ['base', 'api', LANG]
  }

  async function getBySlug(slug: string) {
    return get<PageDetail>([DOMAIN, slug]) // TODO: langPath: ['base', 'api', LANG]
  }

  async function translateSlug(slug: string) {
    return get<SlugTranslation>([DOMAIN, slug, DOMAIN_TRANSLATE]) // TODO: langPath: ['base', 'api', LANG],
  }

  return {
    getAll,
    getByNid,
    getBySlug,
    translateSlug,
  }
}
